import React, { useEffect, useState } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Comment, DealBtnPark } from "@/module";
import { Modal, Icon } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import "./style.less";

const NAME = "expertInfo";

const App = () => {
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[{ show, hide, width = 800, expertId = "", avatar }]] = useWatchState([
    "modal." + NAME,
  ]);

  const [data, setData] = useState({});

  useEffect(() => {
    if (expertId) {
      BaseService.list({
        table: "thtt_zhuanjia",
        columns: "name,qualification",
        where: {
          expert_id: expertId,
          is_delete: 0,
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [expertId]);

  return (
    <Modal
      visible={show}
      width={width}
      className="m-expertInfo"
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
    >
      <div className="flex">
        <div className="m-expertInfo_cover">
          <img
            className="absolute w-full h-full object-cover"
            src={createFilePath(avatar, UPLOAD_SERVER_HOST)}
            alt=""
          />
        </div>
        <div>
          <p className="line-title">Name</p>
          <h2 className="pl-20">{data.name}</h2>
          <p className="line-title mt-20">Introduction</p>

          {/* 产业园区机构背景介绍 */}

          {data.qualification !== "<p></p>" && (
            <article className="m-md-t pl-20">
              <div
                className="m-sm-t braft-output-content"
                dangerouslySetInnerHTML={{ __html: data.qualification }}
              ></div>
            </article>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default App;
